import { DOCUMENT, Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core'

@Injectable({
	providedIn: 'root',
})
export class ManageHeadElements {
	private renderer: Renderer2
	constructor(
		rendererFactory: RendererFactory2,
		@Inject(DOCUMENT) private document: Document,
	) {
		this.renderer = rendererFactory.createRenderer(null, null)
	}

	addScript(data: any[], id: string): void {
		let googleFAQStructuredData = {
			'@context': 'https://schema.org',
			'@type': 'FAQPage',
			mainEntity: data,
		}

		const script = this.document.createElement('script')
		script.setAttribute('type', 'application/ld+json')
		script.setAttribute('id', id)
		script.textContent = JSON.stringify(googleFAQStructuredData)
		this.document.head.appendChild(script)
	}

	removeScript(id: string): void {
		const scripts = this.document.getElementsByTagName('script')
		for (let i = 0; i < scripts.length; i++) {
			if (scripts[i].id === id) {
				this.document.head.removeChild(scripts[i])
			}
		}
	}

	addLink(relType: string, href: string): void {
		const link = this.renderer.createElement('link')
		this.renderer.setAttribute(link, 'rel', relType)
		this.renderer.setAttribute(link, 'href', href)
		this.renderer.appendChild(this.document.head, link)
	}

	addGTMScript(): void {
		// Replace 'GTM-XXXXXX' with your actual GTM Container ID
		const gtmContainerId = 'GTM-PSDJ85L9'

		// Create the script element for the GTM head snippet
		const script = this.document.createElement('script')
		script.id = "GTMscript"
		script.async = true
		script.src = `https://www.googletagmanager.com/gtag/js?id=${gtmContainerId}`

		// Create the inline script for dataLayer and gtag function
		const inlineScript = this.document.createElement('script')
		inlineScript.innerHTML = `
		window.dataLayer = window.dataLayer || [];
		function gtag(){dataLayer.push(arguments);}
		gtag('js', new Date());
		gtag('config', '${gtmContainerId}');
		`

		// Append the scripts to the <head> of the document
		this.document.head.appendChild(script)
		this.document.head.appendChild(inlineScript)
	}

	addOneTrust(): void {
		let script2: HTMLScriptElement = this.document.createElement('script')
		script2.type = 'text/javascript'
		script2.innerHTML =
			'(function () {\n' +
			"var ot = document.createElement('script'); ot.type = 'text/javascript';\n" +
			"ot.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';\n" +
			"ot.charset = 'UTF-8';\n" +
			"ot.setAttribute('data-domain-script','019451a0-aa1a-7ec3-9d77-5e406f0ae7f1');\n" +
			"var s = document.getElementsByTagName('meta')[0];\n" +
			's.parentNode.insertBefore(ot, s); \n' +
			'})();\n'
		let head = this.document.getElementsByTagName('head')[0]
		head.appendChild(script2)

		let script: HTMLScriptElement = this.document.createElement('script')
		script.type = 'text/javascript'
		script.innerHTML = '\nfunction OptanonWrapper() { }\n'
		let metaTag = document.getElementsByTagName('meta')[0]
		metaTag.parentNode?.insertBefore(script, metaTag)
	}
}
